(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eb-delivery-checker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.eb-delivery-checker__button');
    if (!button) return;
    const root = button.closest('[data-eb-delivery-checker]');
    if (!root) return;
    event.preventDefault();
    window.ebShowDeliveryDate(root);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest('.eb-delivery-checker__input');
    if (!input) return;
    const root = input.closest('[data-eb-delivery-checker]');
    if (!root) return;
    event.preventDefault();
    window.ebShowDeliveryDate(root);
  });

  window.ebShowDeliveryDate = (root) => {
    const input = root.querySelector('.eb-delivery-checker__input');
    const result = root.querySelector('.eb-delivery-checker__result');
    const pin = (input.value || '').replace(/\D/g, '');
    input.value = pin;
    result.hidden = false;

    if (pin.length !== 6) {
      result.className = 'eb-delivery-checker__result is-error';
      result.textContent = 'Enter a valid 6-digit PIN code.';
      return;
    }

    const delivery = new Date();
    delivery.setDate(delivery.getDate() + 7);
    const formatted = delivery.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    });
    result.className = 'eb-delivery-checker__result is-success';
    result.innerHTML = `Get it by <span class="eb-delivery-checker__date">${formatted}</span>`;
  };
  } catch(e) { console.error(e); }
})();

})();
